import { Component, OnInit, computed, inject } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';

import { AuthService } from '../core/auth/auth.service';
import { CaseUnreadService } from '../core/case-unread/case-unread.service';
import { HandoffBadgeService } from '../core/handoff-badge/handoff-badge.service';
import { OperatorSocketService } from '../core/socket/operator-socket.service';

type NavItem = {
  label: string;
  icon: string;
  route: string;
  exact?: boolean;
  addRoute?: string;
  superAdminOnly?: boolean;
};

@Component({
  selector: 'op-shell',
  imports: [RouterOutlet, RouterModule, MatIconModule],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class ShellComponent implements OnInit {
  readonly auth = inject(AuthService);
  readonly isSuperAdmin = computed(() => this.auth.user()?.role === 'SUPERADMIN');
  readonly handoffBadge = inject(HandoffBadgeService);
  readonly caseUnread = inject(CaseUnreadService);
  private readonly socket = inject(OperatorSocketService);

  readonly navItems: NavItem[] = [
    { label: 'Available', icon: 'inventory_2', route: '/available', exact: false },
    { label: 'My Cases', icon: 'folder_copy', route: '/my-cases', exact: false },
    { label: 'Confirmed/Completed', icon: 'task_alt', route: '/confirmed-completed' },
    { label: 'Providers', icon: 'engineering', route: '/providers', addRoute: '/providers/new', exact: false },
    { label: 'Service Categories', icon: 'category', route: '/service-categories', addRoute: '/service-categories/new', exact: false },
    { label: 'All Orders', icon: 'archive', route: '/search' },
    { label: 'Customers', icon: 'people', route: '/customers', exact: false },
    { label: 'Statistics', icon: 'insights', route: '/stats', superAdminOnly: true },
  ];

  async ngOnInit(): Promise<void> {
    try {
      await this.socket.connect();
    } catch (err) {
      console.warn('[Shell] WS connect failed', err);
    }
  }

  async signOut(): Promise<void> {
    this.socket.disconnectAndReset();
    await this.auth.signOut();
  }
}